import { useTranslate } from 'react-polyglot'

export default function useTranslatedSmartCount(keys: string[], count: number) {
  const t = useTranslate()
  const TRANSLATION_KEY = keys?.map((key) => t(key))?.join(' |||| ')

  return t(TRANSLATION_KEY, {
    smart_count: count,
  })
}
